/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddOrUpdateGoodsVo } from './AddOrUpdateGoodsVo';
import {
    AddOrUpdateGoodsVoFromJSON,
    AddOrUpdateGoodsVoFromJSONTyped,
    AddOrUpdateGoodsVoToJSON,
    AddOrUpdateGoodsVoToJSONTyped,
} from './AddOrUpdateGoodsVo';

/**
 * 
 * @export
 * @interface ResponseListAddOrUpdateGoodsVo
 */
export interface ResponseListAddOrUpdateGoodsVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListAddOrUpdateGoodsVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListAddOrUpdateGoodsVo
     */
    message?: string;
    /**
     * 
     * @type {Array<AddOrUpdateGoodsVo>}
     * @memberof ResponseListAddOrUpdateGoodsVo
     */
    data?: Array<AddOrUpdateGoodsVo>;
}

/**
 * Check if a given object implements the ResponseListAddOrUpdateGoodsVo interface.
 */
export function instanceOfResponseListAddOrUpdateGoodsVo(value: object): value is ResponseListAddOrUpdateGoodsVo {
    return true;
}

export function ResponseListAddOrUpdateGoodsVoFromJSON(json: any): ResponseListAddOrUpdateGoodsVo {
    return ResponseListAddOrUpdateGoodsVoFromJSONTyped(json, false);
}

export function ResponseListAddOrUpdateGoodsVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListAddOrUpdateGoodsVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(AddOrUpdateGoodsVoFromJSON)),
    };
}

export function ResponseListAddOrUpdateGoodsVoToJSON(json: any): ResponseListAddOrUpdateGoodsVo {
    return ResponseListAddOrUpdateGoodsVoToJSONTyped(json, false);
}

export function ResponseListAddOrUpdateGoodsVoToJSONTyped(value?: ResponseListAddOrUpdateGoodsVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(AddOrUpdateGoodsVoToJSON)),
    };
}

